import axios from "axios";
import {DossierStepsDto} from "types/DTOs/dossierStepsDto";


export const getSteps = async (id: string) => {
  const {data} = await axios.get<DossierStepsDto>(`/dossiers/${id}/steps`);
  return data
}
